
import { defineComponent } from 'vue'
import { filterDefault } from '@/helpers/commons/filterHelper'
import Checkbox from 'primevue/checkbox'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import lovsManagementSimpleDatatableDescriptor from './LovsManagementSimpleDatatableDescriptor.json'
import RadioButton from 'primevue/radiobutton'

export default defineComponent({
    name: 'lovs-management-simple-datatable',
    components: { Checkbox, Column, DataTable, RadioButton },
    props: {
        tableData: {
            type: Object
        },
        treeListTypeModel: {
            type: Object,
            required: true
        }
    },
    emits: ['modelChanged'],
    data() {
        return {
            lovsManagementSimpleDatatableDescriptor,
            filters: { global: [filterDefault] } as Object,
            data: {} as any,
            model: {} as any,
            selectedValue: null,
            selectedDescription: null,
            selectedVisible: [] as any[],
            visibleOptions: [] as any[]
        }
    },
    watch: {
        tableData() {
            this.loadData()
        },
        treeListTypeModel() {
            this.loadModel()
        }
    },
    created() {
        this.loadData()
        this.loadSelectedModel()
        this.loadModel()
    },
    mounted() {
        this.setSelectedValue()
        this.setSelectedDescription()
        this.setSelectedVisible()
    },
    methods: {
        loadData() {
            this.data = this.tableData as any
            this.visibleOptions = []
            if (this.data && this.data.length > 0) {
                this.data.forEach((el: any) => this.visibleOptions.push(el.name))
            }
        },
        loadModel() {
            this.model = this.treeListTypeModel as any
        },
        loadSelectedModel() {
            this.selectedValue = this.treeListTypeModel['VALUE-COLUMN'] as any
            this.selectedDescription = this.treeListTypeModel['DESCRIPTION-COLUMN'] as any

            this.selectedVisible = []
            this.treeListTypeModel['VISIBLE-COLUMNS'].split(',').forEach((el: any) => {
                if (el) {
                    this.selectedVisible.push(el)
                }
            })
        },
        setSelectedValue() {
            this.model['VALUE-COLUMN'] = this.selectedValue
            this.$emit('modelChanged', this.model)
        },
        setSelectedDescription() {
            this.model['DESCRIPTION-COLUMN'] = this.selectedDescription
            this.$emit('modelChanged', this.model)
        },
        setSelectedVisible() {
            // sorting columns based on the order of user input
            let tmpVisibleOptions: string[] = []

            this.visibleOptions?.forEach((el: string) => { 
                if (this.selectedVisible.includes(el)) {
                    tmpVisibleOptions.push(el)
                }
            })
            this.selectedVisible = tmpVisibleOptions
            this.model['VISIBLE-COLUMNS'] = this.selectedVisible.toString()
            this.$emit('modelChanged', this.model)
        }
    }
})
